import reduxCrud from 'redux-crud';

const tripUpdatesActionCreators = reduxCrud.actionCreatorsFor('tripUpdates', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('tripUpdates', { key: 'id' });

export default tripUpdatesActionCreators;
export { actionTypes };
